import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { appActions } from 'features/app';

const useApp = () => {
  const dispatch = useDispatch();
  const openDeleteDialog = useCallback(({ type, id }) => dispatch(appActions.openDeleteDialog({ type, id })), [dispatch]);
  const closeDeleteDialog = useCallback(() => dispatch(appActions.closeDeleteDialog()), [dispatch]);
  const openFillTemplateDialog = useCallback(() => dispatch(appActions.openFillTemplateDialog()), [dispatch]);
  const closeFillTemplateDialog = useCallback(() => dispatch(appActions.closeFillTemplateDialog()), [dispatch]);
  const openFilePreviewDialog = useCallback((file) => dispatch(appActions.openFilePreviewDialog(file)), [dispatch]);
  const closeFilePreviewDialog = useCallback(() => dispatch(appActions.closeFilePreviewDialog()), [dispatch]);
  const setManagerDrawer = useCallback(({ open, edit }) => dispatch(appActions.setManagerDrawer({ open, edit })), [dispatch]);
  const setLocationDrawer = useCallback(({ open, edit }) => dispatch(appActions.setLocationDrawer({ open, edit })), [dispatch]);
  const setClinicianDrawer = useCallback(({ open, edit }) => dispatch(appActions.setClinicianDrawer({ open, edit })), [dispatch]);
  const setSixthFlowPromptsDrawer = useCallback(({ open, edit, id, title, text }) => dispatch(appActions.setSixthFlowPromptsDrawer({ open, edit, id, title, text })), [dispatch]);
  const setSuperbillGoalDrawer = useCallback(({ open, edit, id }) => dispatch(appActions.setSuperbillGoalDrawer({ open, edit, id })), [dispatch]);
  const setEsignFlowDrawer = useCallback(({ open }) => dispatch(appActions.setEsignFlowDrawer({ open })), [dispatch]);
  const setAbortController = useCallback(abortController => dispatch(appActions.setAbortController(abortController)), [dispatch]);

  return { 
    openDeleteDialog, 
    closeDeleteDialog,
    openFillTemplateDialog, 
    closeFillTemplateDialog,
    openFilePreviewDialog,
    closeFilePreviewDialog, 
    setManagerDrawer,
    setLocationDrawer,
    setClinicianDrawer,
    setSixthFlowPromptsDrawer,
    setSuperbillGoalDrawer,
    setEsignFlowDrawer,
    setAbortController
  };
};

export default useApp;